import Vue from "vue";
import Vuex from "vuex";

import { Plugins } from "@capacitor/core";
const { Storage } = Plugins;

import subscriptions from "./modules/subscriptions";
import articles from "./modules/articles";
import documents from "./modules/documents";
import users from "./modules/users";
import contacts from "./modules/contacts";
import fixtures from "./modules/fixtures";
import messaging from "./modules/messaging";
import stamps from "./modules/stamps";
import annotations from "./modules/annotations";
import search from "./modules/search";
import storage from "./modules/storage";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    subscriptions,
    articles,
    documents,
    users,
    contacts,
    fixtures,
    messaging,
    annotations,
    stamps,
    search,
    storage,
  },

  state: {
    eula: false,
    authorization: "",
    online_status: true,
    desktop: false,
    height: 0,
    width: 0,
    menu_items: [],
    menu_details: {
      title: "",
      slug: "",
    },
    activeMenu: true,
    manual_back_button: true,
    current_page: null,
    previous_backURL: null,
    backURL: null,
    animation: "next",
    syncing: false,
    lastSync: "",
    fcmToken: false,
    lastBuildVersion: false,
    currentBuild: 73,
    backgroundSyncing: false,
    syncProgress: {
      total: 0,
      completed: 0,
      currentTask: "",
    },
  },

  mutations: {
    setEula(state, data) {
      Storage.set({
        key: "eula",
        value: data,
      });

      state.eula = data;
    },

    setSync(state, data) {
      state.syncing = data;
    },

    setFCMToken(state, data) {
      state.fcmToken = data;
    },

    setLastSync(state, data) {
      state.lastSync = data;
    },

    setAuthorization(state, data) {
      Storage.set({
        key: "authorization",
        value: data,
      });
      state.authorization = data;
    },

    setLastBuild(state, data) {
      Storage.set({
        key: "last_build",
        value: data,
      });
      state.lastBuildVersion = data;
    },

    setOnlineStatus(state, data) {
      state.online_status = data;
    },

    setDesktop(state, data) {
      Vue.set(state, "desktop", data);
    },

    setHeight(state, data) {
      Vue.set(state, "height", data);
    },

    setWidth(state, data) {
      Vue.set(state, "width", data);
    },

    setMenuItems(state, data) {
      state.menu_items = data;
    },

    setMenuDetails(state, data) {
      state.menu_details = data;
    },

    setPreviousPage(state, data) {
      state.previous_page = data;
    },

    setBackURL(state, data) {
      state.previous_backURL = state.backURL;
      state.backURL = data;
    },

    setAnimation(state, data) {
      state.animation = data;
    },

    setActiveMenu(state, data) {
      state.activeMenu = data;
    },
    setBackgroundSync(state, status) {
      state.backgroundSyncing = status;
    },
    updateSyncProgress(state, { total, completed, task }) {
      state.syncProgress.total = total;
      state.syncProgress.completed = completed;
      state.syncProgress.currentTask = task;
    },
  },

  actions: {
    checkEula({ state, dispatch }) {
      return new Promise((resolve, reject) => {
        Storage.get({ key: "eula" }).then((response) => {
          if (response.value) {
            state.eula = response.value;
            resolve();
          } else {
            reject();
          }
        });
      });
    },

    checkAuthorization({ state, dispatch }) {
      return new Promise((resolve, reject) => {
        Storage.get({ key: "authorization" }).then((response) => {
          if (response.value) {
            state.authorization = response.value;
            dispatch("updateData");
            resolve();
          } else {
            reject();
          }
        });
      });
    },

    clearData({ state, commit, dispatch }) {
      return new Promise((resolve) => {
        state.authorization = "";

        dispatch("clearSubscriptionsData");
        dispatch("clearArticlesData");
        dispatch("clearAnnotationsList");
        dispatch("clearSharedAnnotations");
        dispatch("clearDocumentsData");
        dispatch("clearUserData");
        dispatch("clearContactsData");
        dispatch("clearFixturesData");
        dispatch("clearStamps");

        Storage.clear().then(() => {
          if (state.eula) {
            commit("setEula", state.eula);
          }

          resolve();
        });
      });
    },

    updateData({ dispatch, rootState }) {
      if (!rootState.authorization) {
        return;
      }
      dispatch("getSubscriptionData");
      dispatch("fetchBuildingProfile");
      dispatch("getArticlesData");
      dispatch("getDocumentsData");
      dispatch("getUserData");
      dispatch("getContactsData");
      dispatch("getContactTypesData");
      dispatch("getFixturesData");
      dispatch("getFixtureTypesData");
      dispatch("getAnnotationsList");
      dispatch("getSharedAnnotations");
      dispatch("getStampsList");
      dispatch("registerPushToken");
      dispatch("checkSubscriptionCache");
      dispatch("checkDocumentsCache");
    },

    handleOnlineStatusChange({ dispatch, commit, rootState }) {
      // wait a second, and then fire off queues
      setTimeout(() => {
        if (rootState.authorization) {
          dispatch("processAnnotationQueue");
          dispatch("fetchDocuments");
          dispatch("fetchStamps");
          dispatch("checkSubscriptionCache");
          dispatch("checkDocumentsCache");
        }
      });
    },

    async fetchInitialData({ dispatch, commit }) {
      /* Below commented code is old representation */

  /*     await dispatch('fetchAllStamps');
      let fetchArticles = dispatch('fetchArticles'),
          fetchDocuments = dispatch('fetchDocuments'),
          fetchStamps = dispatch('fetchStamps'),
          fetchAnnotations = dispatch('fetchAnnotations'),
          fetchSharedAnnotations = dispatch('fetchSharedAnnotations'),
          fetchUser = dispatch('fetchUser'),
          fetchBuildingProfile = dispatch('fetchBuildingProfile'),
          fetchContacts = dispatch('fetchContacts'),
          fetchContactTypes = dispatch('fetchContactTypes'),
          fetchFixtures = dispatch('fetchFixtures'),
          fetchFixtureTypes = dispatch('fetchFixtureTypes');
      return Promise.all([fetchArticles, fetchDocuments, fetchAnnotations, fetchSharedAnnotations, fetchUser, fetchContacts, fetchContactTypes, fetchBuildingProfile, fetchFixtures, fetchFixtureTypes, fetchStamps]);
 */

      await dispatch('initializeStamps');
      dispatch("runPostLoginBackgroundSync");

      // Critical metadata needed immediately
       await dispatch('fetchUser');
            await dispatch('fetchBuildingProfile');
            await dispatch('fetchContactTypes');
            await dispatch('fetchFixtureTypes');

            // // Lists - should be proper JSON lists only
            await dispatch('fetchAnnotations');
            await dispatch('fetchSharedAnnotations');
            await dispatch('fetchContacts');
            await dispatch('fetchFixtures');

            return Promise.resolve();
           

      /* This code is new implementation for fast login */

   /*    try {
        // PHASE 1: Critical data (blocks)
        console.log("🚀 Starting fast login - fetching critical data...");
        await Promise.all([
          dispatch("fetchUser"),
          dispatch("fetchBuildingProfile"),
        ]);
        console.log("✅ Critical data loaded");
        
        // PHASE 2 & 3: Background sync
        console.log("🔄 Starting background sync...");
        commit("setBackgroundSync", true);

        // Track when sync started for minimum display time
        const syncStartTime = Date.now();

        const backgroundTasks = [
          { action: "fetchContactTypes", name: "Contact Types" },
          { action: "fetchFixtureTypes", name: "Fixture Types" },
          { action: "fetchAnnotations", name: "Annotations" },
          { action: "fetchSharedAnnotations", name: "Shared Annotations" },
          { action: "fetchContacts", name: "Contacts" },
          { action: "fetchFixtures", name: "Fixtures" },
          { action: "fetchArticles", name: "Articles" },
          { action: "fetchDocuments", name: "Documents" },
          { action: "fetchStamps", name: "Stamps" }, // Only fetches stamp list, not images
        ];
        
        // Execute all background tasks
        Promise.all(
          backgroundTasks.map((task) =>
            dispatch(task.action)
              .then(() => {
                console.log(`✅ ${task.name} loaded`);
              })
              .catch((err) => {
                console.error(`❌ Failed to fetch ${task.name}:`, err);
              }),
          ),
        ).then(async () => {
          // Ensure sync indicator shows for at least 3 seconds
          const syncDuration = Date.now() - syncStartTime;
          const minDisplayTime = 5000; // 3 seconds
          
          if (syncDuration < minDisplayTime) {
            await new Promise(resolve => setTimeout(resolve, minDisplayTime - syncDuration));
          }
          
          console.log("✅ Background sync complete");
          commit("setBackgroundSync", false);
          commit("setLastSync", new Date().toISOString());
        });
        
        return Promise.resolve();
      } catch (error) {
        console.error("❌ Critical data fetch failed:", error);
        commit("setBackgroundSync", false);
        throw error;
      } */
    },

    async runPostLoginBackgroundSync({ dispatch, commit }) {
      commit("setBackgroundSync", true);
      const syncStartTime = Date.now();
      const minSyncDisplayMs = 10000;

      try {
        await Promise.all([
          dispatch("fetchStamps"),
          dispatch("fetchAllStamps"),
          dispatch("fetchArticles"),
          dispatch("fetchDocuments"),
        ]);
      } catch (err) {
        console.error("Background sync failed:", err);
      } finally {
        const elapsed = Date.now() - syncStartTime;
        if (elapsed < minSyncDisplayMs) {
          await new Promise((resolve) =>
            setTimeout(resolve, minSyncDisplayMs - elapsed),
          );
        }
        commit("setBackgroundSync", false);
        commit("setLastSync", new Date().toISOString());
      }
    },

    checkOnlineStatus({ commit, dispatch, state }) {
      console.warn("Checking status");
      if (navigator.onLine && state.online_status !== navigator.onLine) {
        dispatch("handleOnlineStatusChange");
      }
      commit("setOnlineStatus", navigator.onLine);
    },
  },

  getters: {
    getHeight: (state) => {
      return state.height;
    },

    getOffline: (state) => {
      return state.online_status;
    },

    getFCMToken: (state) => {
      return state.fcmToken;
    },

    getSyncing: (state) => {
      return state.syncing;
    },

    getLastSync: (state) => {
      return state.lastSync;
    },

    getActiveMenu: (state) => {
      return state.activeMenu;
    },
  },
});

export default store;
